const NoPage = () => {
  return <p>Error: 404</p>;
};

export default NoPage;
